export enum OrderItemMiscType {
    StockKeepingUnit = 0,
    StartKit = 1
}
